import { ReactElement } from "react";
import { ActivitiesContainer } from "../Container/ActivitiesContainer";
import {
	MutedActivityFilterKind,
	MutedActivityFilterModel,
	VolatileActivitiesClientModel
} from "client/Api/Notifications/notifications";
import { useActivityFeedStore } from "../store";
import { AppointmentActivity } from "./AppointmentActivity/AppointmentActivity";

export const VolatileActivities = (): ReactElement | null => {
	const muteFilters: readonly MutedActivityFilterModel[] = useActivityFeedStore(s => s.muteFilters);
	const volatileActivities: VolatileActivitiesClientModel | null = useActivityFeedStore(s => s.volatileActivities);
	const isAppointmentMuted: boolean = muteFilters.some(f => f.kind === MutedActivityFilterKind.Appointment);

	if (!volatileActivities) {
		return null;
	}

	const {
		appointment
	} = volatileActivities;

	return (
		<ActivitiesContainer>
			{appointment && !isAppointmentMuted &&
				<AppointmentActivity appointment={appointment} />
			}
		</ActivitiesContainer>
	);
};

VolatileActivities.displayName = "VolatileActivities";
